import { Phone, Mail, MapPin, Clock, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const GMAPS = "https://www.google.com/maps/search/?api=1&query=174+Hospital+Dr+Raton+New+Mexico+87740";
const AMAPS = "https://maps.apple.com/?q=174+Hospital+Dr+Raton+New+Mexico+87740";
const FACILITY = "https://customer-assets-jt897jd0.emergentagent.net/job_meds-admin-dashboard/artifacts/wpi9i5xz_cp.front.jpg";

export default function Contact() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-16">
      <div className="mb-10 max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Get in touch</span>
        <h1 className="mt-2 font-heading text-4xl font-bold tracking-tight">Contact Crystal Pharmacy</h1>
        <p className="mt-3 text-muted-foreground">We're here to help. Reach us by phone, email, or stop by our Raton location.</p>
      </div>

      <div className="grid gap-8 lg:grid-cols-2">
        <div className="space-y-5">
          <div className="flex items-start gap-4 rounded-2xl border border-border bg-card p-6" data-testid="contact-phone">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary"><Phone className="h-6 w-6" /></div>
            <div>
              <h3 className="font-heading font-bold">Phone</h3>
              <a href="tel:5753957559" className="text-primary hover:underline">575-395-7559</a>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-2xl border border-border bg-card p-6" data-testid="contact-email">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary"><Mail className="h-6 w-6" /></div>
            <div>
              <h3 className="font-heading font-bold">Email</h3>
              <a href="mailto:crystalpharmacyraton@gmail.com" className="break-all text-primary hover:underline">crystalpharmacyraton@gmail.com</a>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-2xl border border-border bg-card p-6" data-testid="contact-address">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary"><MapPin className="h-6 w-6" /></div>
            <div>
              <h3 className="font-heading font-bold">Address</h3>
              <p className="text-muted-foreground">174 Hospital Dr, Raton, New Mexico 87740</p>
              <div className="mt-3 flex flex-wrap gap-2">
                <Button asChild size="sm" variant="outline" className="rounded-full">
                  <a href={GMAPS} target="_blank" rel="noreferrer" data-testid="contact-google-maps">Google Maps <ExternalLink className="ml-1 h-3 w-3" /></a>
                </Button>
                <Button asChild size="sm" variant="outline" className="rounded-full">
                  <a href={AMAPS} target="_blank" rel="noreferrer" data-testid="contact-apple-maps">Apple Maps <ExternalLink className="ml-1 h-3 w-3" /></a>
                </Button>
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-2xl border border-border bg-card p-6" data-testid="contact-hours">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary"><Clock className="h-6 w-6" /></div>
            <div>
              <h3 className="font-heading font-bold">Hours</h3>
              <ul className="text-muted-foreground">
                <li>Monday – Friday: 9:00 AM – 6:00 PM</li>
                <li>Saturday & Sunday: 10:00 AM – 5:00 PM</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="overflow-hidden rounded-3xl border border-border shadow-lg">
          <img src={FACILITY} alt="Crystal Pharmacy storefront" className="h-96 w-full object-cover object-bottom" />
          <iframe
            title="Crystal Pharmacy location"
            className="h-72 w-full border-0"
            loading="lazy"
            src="https://www.google.com/maps?q=174+Hospital+Dr+Raton+New+Mexico+87740&output=embed"
          />
        </div>
      </div>
    </div>
  );
}
